import { useEventDispatcher } from "@otto-ec/otto-components-utils/use/event-dispatcher";

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export function setMounted(
  component: string,
  host: HTMLElement & { mounted: boolean },
  mounted: boolean,
): void {
  host.mounted = mounted;

  const dispatch = useEventDispatcher(host, false);
  const payload = { component, element: host };

  setTimeout(() =>
    mounted
      ? dispatch(`${component}-mount`, payload, { cancelable: false, alias: ["oc-mount"] })
      : dispatch(`${component}-unmount`, payload, { cancelable: false, alias: ["oc-unmount"] }),
  );
}
